import { ChevronDown, ChevronRight } from 'react-feather';
import DoorWindows from '../orderSections/DoorWindows';

const OrderDoorsWindowsSection = ({
	sections,
	toggleSection,
	onSelectionsChange,
	centerStorage,
	leftLean,
	rightLean,
	frontLean,
	backLean,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div
					className="title-block"
					onClick={(e) => toggleSection('doorsTab', e)}
				>
					<h2 className="title-h2">Doors, windows, & frameouts</h2>
					<button>
						{sections.doorsTab ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.doorsTab && (
					<DoorWindows
						onSelectionsChange={onSelectionsChange}
						centerStorage={centerStorage}
						leftLean={leftLean}
						rightLean={rightLean}
						frontLean={frontLean}
						backLean={backLean}
					/>
				)}
			</div>
		</div>
	);
};

export default OrderDoorsWindowsSection;
